<template>
    <div class="mt-12">
        <Link
            class="header-class header-link !mb-2 mt-4"
            :href="`/${sport}/america-east`"
            >{{ gender }}'s America East Standings</Link
        >
        <table class="w-full">
            <thead>
                <tr class="border-b border-slate-600/50">
                    <td class="pr-3 text-right">School</td>
                    <td class="text-right">Overall</td>
                    <td class="text-right">Pct</td>
                    <td class="text-right">Conf</td>
                    <td class="text-right">Pct</td>
                    <td class="text-right">Streak</td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="s in standings" class="text-slate-400">
                    <td class="pr-3 text-right">
                        <Link
                            :href="`/${sport}/america-east/${urlify(s.team.short_name)}`"
                            class="hover:text-yellow-200 hover:underline"
                            >{{ s.team.school }}</Link
                        >
                    </td>
                    <td class="text-right">
                        {{ s.total_wins }}-{{ s.total_losses }}
                    </td>
                    <td class="text-right">{{ s.total_pct }}</td>
                    <td class="text-right">
                        {{ s.conf_wins }}-{{ s.conf_losses }}
                    </td>
                    <td class="text-right">{{ s.conf_pct }}</td>
                    <td class="pt-[2px] text-right font-mono">
                        {{ s.team.streak }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { urlify } from '@/utils/Utilities';
import { Link } from '@inertiajs/vue3';

export default {
    name: 'BasketballStandings',
    props: ['gender', 'standings'],
    components: { Link },
    computed: {
        sport() {
            return this.gender === 'women' ? 'wbb' : 'mbb';
        },
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {
        urlify,
    },
};
</script>
